"use client";
import { useState, useEffect } from "react";

const ProgressBar = () => {
  const [scrolled, setScrolled] = useState(0);

  useEffect(() => {
    window.addEventListener("scroll", scrollProgress);
    return () => {
      window.removeEventListener("scroll", scrollProgress);
    };
  });

  const scrollProgress = () => {
    const scrollPx = document.documentElement.scrollTop;
    const winHeightPx =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;
    const scrolledProg = `${(scrollPx / winHeightPx) * 100}`;
    // console.log(scrolledProg);
    setScrolled(+scrolledProg);
  };
  return (
    <div className=" bg-white h-[0.3rem] w-[98.7vw] z-50">
      <div
        style={{
          background: "#31EB97",
          width: `${scrolled}%`,
          height: "5px",
        }}
      />
    </div>
  );
};

export default ProgressBar;
